import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";

export const generarSceneModal = (nombre) => {
  const scene = new THREE.Scene();
  scene.userData.nombre = nombre;
  const element2 = document.createElement("div");
  element2.className = "col-md-12 mx-auto d-block";
  // element2.className = " mx-auto d-block";
  // element2.className = "col-md-12  mt-3 mb-3";
  element2.style.zIndex = "99995";
  const element = document.createElement("div");
  // element.className = "list-item col-md-4 col-lg-3";
  element.className = "list-modal";
  element.style.zIndex = "99996";
  element.style.cursor = "grab";
  // element2.style.position = "static";
  element2.appendChild(element);
  // element.style.position = "absolute";
  // element.style.top = "0px";
  // element.style.left = "0px";

  const sceneElement = document.createElement("div");
  // sceneElement.style.position = "static";
  // sceneElement.style.width = '100'
  // sceneElement.style.marginLeft = "-200px";
  element.appendChild(sceneElement);
  element.style.cursor = "grab";
  // element.id = "div-modal-element";

  // const descriptionElement = document.createElement("div");
  // descriptionElement.innerText = "Escena principal ";
  // element.appendChild(descriptionElement);

  // the element that represents the area we want to render the scene
  scene.userData.element = sceneElement;

  const light = new THREE.DirectionalLight(0xffffff, 0.5);
  light.position.set(1, 1, 1);
  //  scene.add(light);
  // console.log("scene es, ", scene);
  // scene.background = new THREE.Color("#CCCCCC");
  const camera = new THREE.PerspectiveCamera(50, 1, 1, 10);
  camera.position.z = -3;
  scene.userData.camera = camera;

  const controls = new OrbitControls(
    scene.userData.camera,
    scene.userData.element
  );
  controls.minDistance = 2;
  controls.maxDistance = 5;
  controls.enablePan = false;
  controls.enableZoom = true;
  scene.userData.controls = controls;

  /**
   * Lights
   */
  const directionalLight = new THREE.DirectionalLight("#ffffff", 2);
  directionalLight.position.set(0, 1, 2);
  scene.add(directionalLight);
  const directionalLight2 = new THREE.DirectionalLight("#ffffff", 3.5);
  directionalLight2.position.set(0, 0, -4);
  scene.add(directionalLight2);
  //   const directionalLight3 = new THREE.DirectionalLight("#ffffff", 1);
  //   directionalLight3.position.set(2, 0, -0.5);
  //   scene.add(directionalLight3);
  //   const directionalLight4 = new THREE.DirectionalLight("#ffffff", 1);
  //   directionalLight4.position.set(-2, 2, -0.5);
  //   scene.add(directionalLight4);
  // const rectAreaLight = new THREE.RectAreaLight(0xffffff, 2, 1, 1);
  // scene.add(rectAreaLight);
  const ambientLight = new THREE.AmbientLight(0xffffff, 10);
  scene.add(ambientLight);

  return [scene, element2];
};
